import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service1 from "../../assets/images/service/01.jpg";

import ImgLaser from "../../assets/images/service_detail/laser-kidney/01.jpg";
import ImgURS from "../../assets/images/service_detail/laser-kidney/02.jpg";
import ImgPCNL from "../../assets/images/service_detail/laser-kidney/03.jpg";
import ImgSWL from "../../assets/images/service_detail/laser-kidney/04.jpg";

const LaserKidneyStone = () => {

const data = {
title:"Laser Kidney Stone Treatment",
subtitle:"Advanced & painless kidney stone removal",

heading:"Get Advanced Laser Kidney Stone Treatment",
description:"Laser kidney stone treatment is a modern and highly effective procedure that uses advanced laser technology to break stones into small fragments. This minimally invasive treatment ensures faster recovery, minimal pain and excellent success rates.",

image:Service1,

sections: [

{
title:"Laser Treatment of Kidney Stone",
content:"Kidney stones are hard mineral deposits formed inside the kidneys due to accumulation of calcium, uric acid or other waste substances. These stones can cause severe flank pain, burning urination, blood in urine and blockage of urine flow. Laser kidney stone treatment is one of the most advanced and effective minimally invasive methods to remove stones without open surgery. At BBMH Hospital, advanced laser technology is used to ensure precise stone removal, minimal pain and faster recovery."
},

{
title:"When Do You Need Surgery for Kidney Stone?",
content:"Surgical treatment is recommended when kidney stones cannot pass naturally or start causing serious complications. Early intervention helps prevent infection and kidney damage.",
list:[
"Large stones that cannot pass through urine naturally",
"Severe pain not relieved by medicines",
"Stone blocking urine flow from kidney",
"Repeated urinary infections due to stone",
"Blood in urine or kidney swelling",
"Risk of permanent kidney damage if untreated"
]
},

{
title:"Types of Kidney Stone Treatments Available",
content:"Treatment depends on stone size, location and patient condition. Modern urology offers multiple minimally invasive options for safe and effective stone removal.",
list:[
"RIRS – Laser stone removal through natural urinary passage without cuts",
"Laser Kidney Stone Treatment – Advanced endoscopic laser procedure",
"Shock Wave Lithotripsy (SWL) – Non-surgical sound wave treatment",
"Ureteroscopy (URS) – Endoscopic removal of ureter stones",
"Mini-PCNL – Minimally invasive removal for medium to large stones",
"PCNL – Surgical removal of large or complex stones",
"Open Surgery – Rarely required in complicated cases"
]
},

{
title:"Laser Kidney Stone Treatment Procedure",
content:"Laser kidney stone treatment is a minimally invasive endoscopic procedure performed through the natural urinary passage. A thin flexible scope is inserted to reach the stone. A high-power laser breaks the stone into fine dust-like particles which either pass naturally through urine or are removed safely. The procedure is highly precise, causes minimal discomfort and allows most patients to go home within 24 hours.",
image: ImgLaser
},

{
title:"Benefits of Laser Kidney Stone Treatment",
content:"Laser technology provides safe and highly effective treatment with faster healing and minimal complications compared to traditional surgery.",
list:[
"No large cuts or stitches",
"Minimal pain and bleeding",
"Short hospital stay",
"Same day or next day discharge",
"High precision and complete stone removal",
"Low risk of complications",
"Faster recovery and return to normal life"
]
},

{
title:"Shock Wave Lithotripsy (SWL)",
content:"Shock Wave Lithotripsy is a non-invasive treatment that uses high-energy sound waves to break kidney stones into smaller fragments. These fragments pass naturally through urine over time. SWL is most suitable for small to medium-sized stones and does not require any incision or anesthesia in many cases.",
image: ImgSWL
},

{
title:"Ureteroscopy (URS) Treatment",
content:"Ureteroscopy is a minimally invasive procedure in which a thin scope is passed through the urinary tract to locate and treat stones in the ureter or kidney. Laser energy is used to fragment larger stones into smaller pieces. The procedure does not involve external cuts and allows quick recovery.",
image: ImgURS
},

{
title:"PCNL for Large Kidney Stones",
content:"Percutaneous Nephrolithotomy (PCNL) is recommended for large or complex kidney stones. A small incision is made in the back to access the kidney and remove stones using specialized instruments. PCNL provides high success rates for large stones while maintaining safety and effectiveness.",
image: ImgPCNL
},

{
title:"Post Treatment Care",
content:"Proper post-treatment care helps prevent recurrence of kidney stones and ensures smooth recovery.",
list:[
"Drink plenty of water daily to prevent stone formation",
"Avoid heavy physical activity for few days",
"Take prescribed medicines regularly",
"Follow a healthy and balanced diet",
"Regular follow-up with doctor",
"Avoid holding urine for long periods"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Laser Kidney Stone Treatment?",
content:"Dr. Sachitanand Chaurasia is one of the most trusted and experienced urologists known for advanced kidney stone treatment. At BBMH (Brijesh Banger Memorial Hospital), patients receive world-class urology care with modern operation theatre, advanced laser machines and complete post-treatment support. Doctor focuses on safe surgery, minimal pain and quick recovery ensuring best results for every patient."
}

],

faq:[
{
q:"Is laser kidney stone treatment painful?",
a:"No, laser treatment is minimally invasive and mostly painless."
},
{
q:"How many days recovery needed?",
a:"Most patients recover within 2-3 days."
},
{
q:"Is laser treatment safe?",
a:"Yes, it is one of the safest treatments for kidney stones."
}
]
};

return <TreatmentFullLayout data={data}/>
};

export default LaserKidneyStone;
